import type { AiAppCenterModule } from '../types'

export const distributionModule: AiAppCenterModule = {
  key: 'distribution',
  label: '配送系统运营端',
  desc: '运力机构 / 运单调度 / 骑手管理',
  path: '/distribution',
  homePath: '/distribution/platform/overview',
  homeTitles: ['概况', '配送运营概况'],
  icon: 'ep:van',
  color: '#0d9488',
  // 勿加「配送管理」：商城交易中心有同名菜单（快递发货/门店自提），独立窗会找错根
  aliases: ['配送系统', '配送运营端', '紫金山骑手运营端', '紫金山骑手端', 'capacity']
}
